/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type CancelEvaluationRunPathParams = NonNullable<operations['cancelEvaluationRun']['parameters']['path']>;

export interface Input extends CancelEvaluationRunPathParams {
  apiVersion?: string;
}

export async function cancelEvaluationRun(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/evaluations/{evaluationId}/runs/{runId}/cancel', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
